// filepath: src/apps/policymaker/pages/PIR/page/PIRCollectionRequestsList.jsx
import React from 'react';
import {Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router';
import {useIcrList} from '../../../../../firebase/firestore/useIcrList';

/**
 * List part: subscribes to PIR children (parent_ir === pirId) and renders them.
 */
export default function PIRCollectionRequestsList({pirId}) {
    const navigate = useNavigate();
    const {data: icrs, loading, error} = useIcrList(pirId);

    if (loading) return <Typography>Loading…</Typography>;
    if (error) return <Typography color="error">Error loading collection
        requests: {String(error?.message || error)}</Typography>;
    if (!icrs || icrs.length === 0) return <Typography>No collection requests found.</Typography>;

    return (
        <Stack spacing={2}>
            {icrs.map(icr => (
                <Stack
                    key={icr.id}
                    p={2}
                    spacing={1}
                    border="1px solid #ddd"
                    bgcolor={'white'}
                    borderRadius={2}
                    onClick={() => navigate(`/icr/${icr.id}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') navigate(`/icr/${icr.id}`);
                    }}
                    sx={{
                        cursor: 'pointer',
                        '&:hover': {borderColor: 'black'}
                    }}
                >
                    <Typography variant={'subtitle2'}>{icr.id}</Typography>
                    <Typography sx={{fontWeight: 600}}>{icr.tasking?.summary || '—'}</Typography>
                    <Typography variant={'body2'} color={'text.secondary'}>Status: {icr.status?.state || 'N/A'} ·
                        Agency: {icr.requester?.agency || 'N/A'}</Typography>
                </Stack>
            ))}
        </Stack>
    );
}
